export const deleteTopicApiUrls = {
	deleteTopic: 'topics/:topicId',
};
